





import {computed, defineComponent} from "@vue/composition-api"
import {WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {buildQueryDownloadUrl, executeQuery} from "@/data/repos/query"
import {getLocationCaption} from "@/data/sources/appraisal"
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Numeric(),
    widget: 'NetInternalArea',
    title: 'Net Internal Area',
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    SimpleTextWidget,
  },
  setup(props, context) {
    context.emit('config-update', config())

    const downloadUrl = computed(() => {
      const params = props.config && props.config.params
      const locationId = parseInt(params.locationId.value)
      return buildQueryDownloadUrl("idr", "netInternalAreaDrillDown",
          {locationId})
    })

    function chartClickCallback() {
      window.open(downloadUrl.value, "_blank")
    }

    return {dataFetcher, chartClickCallback, titleCallback, downloadUrl}
  },
})

async function titleCallback(config: any) {
  return "Location: " + await getLocationCaption(config.params.locationId)
}

async function dataFetcher(params: any): Promise<{}> {
  if (isNaN(parseInt(params.locationId.value))) {
    return {value: "?"}
  }
  const r = await executeQuery("idr", "netInternalArea",
      {locationId: params.locationId.value})
  if (r) {
    return {value: formatNumberWithGrouping(r[0].Value, 1)}
  }
  return "?"
}
